import { WarehouseActionTypes } from '../Constants/Types';
import { WarehouseState } from '../Interfaces/warehouse-interface';

const initialState: WarehouseState = {
  warehouses: [],
  warehouse: null,
  lwarehouses: false,
  lwarehouse: false,
  error: null,
  page: 0,
  total: 0
};

const WarehousesReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case WarehouseActionTypes.LOADING_WAREHOUSES:
      return { ...state, lwarehouses: true };
    case WarehouseActionTypes.LOADING_WAREHOUSE:
      return { ...state, lwarehouse: true };
    case WarehouseActionTypes.GET_WAREHOUSES:
      return {
        ...state,
        warehouses: action.payload.data,
        page: action.payload.page,
        total: action.payload.total,
        lwarehouses: false
      };
    case WarehouseActionTypes.GET_WAREHOUSE:
      return { ...state, warehouse: action.payload, lwarehouse: false };
    case WarehouseActionTypes.CREATE_WAREHOUSE:
      return { ...state, warehouse: action.payload, lwarehouse: false };
    case WarehouseActionTypes.UPDATE_WAREHOUSE:
      return { ...state, warehouse: action.payload, lwarehouse: false };
    case WarehouseActionTypes.REMOVE_WAREHOUSE:
      return { ...state, warehouse: action.payload, lwarehouse: false };
    case WarehouseActionTypes.ERROR_WAREHOUSES:
      return { ...state, lwarehouses: false };
    case WarehouseActionTypes.ERROR_WAREHOUSE:
      return { ...state, lwarehouse: false, error: action.payload };
    default:
      return state;
  }
};

export default WarehousesReducer; 